<template>
  <div>
    <div style="margin: 0 0 10px 0">
      <a-button v-if="estimate == 1 && userType == '00'" type="primary" style="margin-right: 8px" @click="change1"
        >全部订单
      </a-button>
      <a-button v-else-if="estimate == 0 && userType == '00'" type="primary" style="margin-right: 8px" @click="change2">
        个人订单</a-button
      >
      <a-button @click="getSort">排序</a-button>
    </div>
    <a-row :gutter="10">
      <a-col :span="userType == 22 && false ? 18 : 24">
        <!-- 轮播图片  autoplay-->
        <a-carousel v-if="num">
          <div style="width: 24%" v-for="(item, i) in carouselList" :key="i">
            <div style="margin: 0 auto; display: flex; flex-wrap: wrap">
              <div
                style="width: 19%; text-align: left; margin: 0px 0.5% 10px; cursor: pointer"
                v-for="(list, index) in item"
                :key="index"
                @click="change3(list)"
              >
                <div style="height: 100%; background: white" class="pd-15" @click="handleJump(list)">
                  <div class="flex_l">
                    <img style="width: 40px; height: 40px" :src="'/images/' + list.icon" />
                    <div style="font-size: 15px; margin-left: 14px">
                      {{ list.menuName }}
                    </div>
                  </div>
                  <div class="center flex-bottom">
                    <span class="blue bold" style="font-size: 30px">{{ list.num }}</span>
                    <span style="margin: 0 0 10px 5px; font-size: 12px">单</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-carousel>

        <div style="padding: 20px 0; width: 100%">
          <a-row :gutter="15">
            <!-- 通知公告-->
            <!-- <a-col :span="12">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 40px;
              background: white;
              margin-bottom: 20px;
            "
          >
            <span style="font-family: 黑体; font-size: 16px; color: #333333; padding-left: 18px; font-weight: bold"
              >通知公告</span
            >
            <span
              style="font-family: 黑体; font-size: 16px; color: #fc5d5d; cursor: pointer; margin-right: 10px"
              @click="whole"
              >查看全部</span
            >
          </div>
          <div v-for="item in notice2">
            <div
              v-for="(i, index) in item"
              @click="onchange(i)"
              style="cursor: pointer; background: white; padding-top: 0.1px"
            >
              <span style="display: inline-block; margin: 10px 0 0 20px; color: red"> {{ i.title }} </span>
              <span style="float: right; margin: 10px"> {{ i.startTime }} </span>
              <a-divider></a-divider>
            </div>
          </div>
        </a-col> -->
            <!-- 企业单数/在线客服 -->
            <a-col :span="12">
              <div style="background: white; width: 100%; padding: 10px" v-if="interiorTop">
                <p style="font-weight: bold; font-size: 18px" class="center ptb-10">企业单数TOP10</p>
                <a-row :span="24" :gutter="24">
                  <a-col :span="5" :offset="2">
                    <a-button
                      type="primary"
                      @click="topTenOfEnterpriseday(day)"
                      class="qiyedanshuju"
                      v-bind:class="{ activeStyle: isActive == 1 }"
                    >
                      本日数据
                    </a-button>
                  </a-col>
                  <a-col :span="5">
                    <a-button
                      type="primary"
                      @click="topTenOfEnterprisemon(mon)"
                      class="qiyedanshuju"
                      v-bind:class="{ activeStyle: isActive == 2 }"
                    >
                      本月数据
                    </a-button>
                  </a-col>
                  <a-col :span="7">
                    <a-button
                      type="primary"
                      @click="topTenOfEnterpriselastmon(lastmon)"
                      class="qiyedanshuju"
                      v-bind:class="{ activeStyle: isActive == 3 }"
                    >
                      最近30天数据
                    </a-button>
                  </a-col>
                  <a-col :span="5">
                    <a-button
                      type="primary"
                      @click="topTenOfEnterpriseall(all)"
                      class="qiyedanshuju"
                      style="margin-left: -10px"
                      v-bind:class="{ activeStyle: isActive == 4 }"
                    >
                      全部数据
                    </a-button>
                  </a-col>
                </a-row>
                <div style="background-color: #f0efef; height: 30px; line-height: 30px; width: 100%; margin: 15px auto">
                  <a-row type="flex" justify="space-around">
                    <a-col :span="12" :offset="5">
                      <p>企业名称</p>
                    </a-col>
                    <a-col :span="6">
                      <p>下单数</p>
                    </a-col>
                  </a-row>
                </div>
                <div style="width: 100%; position: relative; padding: 10px">
                  <p v-for="(item, i) in topTenOfEnterpriselist" style="text-align: center">
                    <a-row type="flex" justify="space-around">
                      <a-col :span="1" v-if="i == 0"
                        ><img src="../../assets/images/champion.png" style="width: 20px" />
                      </a-col>
                      <a-col :span="1" v-else-if="i == 1"
                        ><img src="../../assets/images/second.png" style="width: 20px"
                      /></a-col>
                      <a-col :span="1" v-else-if="i == 2"
                        ><img src="../../assets/images/third.png" style="width: 20px"
                      /></a-col>
                      <a-col :span="1" v-else>{{ i + 1 }}</a-col>
                      <a-col :span="13">
                        <td>{{ item.enterpriseName }}</td>
                      </a-col>
                      <a-col :span="4" :offset="1">
                        <td>{{ item.enterpriseOrderCount }}</td>
                      </a-col>
                    </a-row>
                  </p>
                </div>
              </div>
              <!-- <a-divider /> -->
              <!-- 在线客服 -->
              <div style="background: white" class="mt-15" v-if="customerService">
                <div>
                  <a-row type="flex" justify="space-around">
                    <a-col :span="22">
                      <p style="font-weight: bold; font-size: 18px" class="center ptb-10">在线客服</p>
                    </a-col>
                  </a-row>
                  <a-row type="flex" justify="space-around">
                    <a-col :span="2">
                      <a-button
                        type="primary"
                        class="qiyedanshuju"
                        @click="showWorkDay('day')"
                        v-bind:class="{ activeStyle: isActive2 == 1 }"
                        ><strong>本日</strong></a-button
                      >
                    </a-col>
                    <a-col :span="2">
                      <a-button
                        type="primary"
                        class="qiyedanshuju"
                        @click="showWorkWeek('week')"
                        v-bind:class="{ activeStyle: isActive2 == 2 }"
                        ><strong>本周</strong></a-button
                      >
                    </a-col>
                    <a-col :span="2">
                      <a-button
                        type="primary"
                        class="qiyedanshuju"
                        @click="showWorkMonth('month')"
                        v-bind:class="{ activeStyle: isActive2 == 3 }"
                        ><strong>本月</strong></a-button
                      >
                    </a-col>
                    <a-col :span="2">
                      <a-button
                        type="primary"
                        class="qiyedanshuju"
                        @click="showWorkAll('all')"
                        v-bind:class="{ activeStyle: isActive2 == 4 }"
                        ><strong>全部</strong></a-button
                      >
                    </a-col>
                  </a-row>
                </div>
                <!-- <a-divider style="width: 95px" /> -->
                <div class="mt-15 pb-10">
                  <a-row type="flex" justify="space-around" align="middle" style="margin-bottom: 10px">
                    <a-col :span="5" style="text-align: center"><strong>客服名称</strong></a-col>
                    <a-col :span="5" style="text-align: center"><strong>接单状态</strong></a-col>
                    <a-col :span="5" style="text-align: center"><strong>订单数</strong></a-col>
                    <a-col :span="5" style="text-align: center"><strong>操作</strong></a-col>
                  </a-row>
                  <a-row type="flex" class="mb-10" justify="space-around" align="middle" v-for="item in zaixiankefu">
                    <a-col :span="5" style="text-align: center">{{ item.name }}</a-col>
                    <a-col :span="5" style="text-align: center">{{ item.assignStatus }}</a-col>
                    <a-col :span="5" style="text-align: center">{{ item.orderNum }}</a-col>
                    <a-col :span="5" style="text-align: center">
                      <span style="cursor: pointer; color: #2c63ff" @click="showModal(item.userId)">详情</span>
                      <a-modal
                        title="客服详情"
                        mask="{false}"
                        :width="kefuWidth"
                        :mackStyle="keMack"
                        :heifht="kefuHeight"
                        v-model="visible"
                        :footer="false"
                        @ok="handleOk"
                      >
                        <div style="margin-left: 25px">
                          <p>客服姓名 : {{ kefuxiangqing.name }}</p>
                          <p>代办事项数 : {{ kefuxiangqing.todoCount }}</p>
                          <p>当月已处理待办事项数 : {{ kefuxiangqing.todoProcessCount }}</p>
                        </div>
                        <div style="text-align: center">
                          <a-button
                            type="primary"
                            @click="showgetOverTimelist(kefuxiangqing.userId)"
                            style="margin-right: 25px"
                          >
                            超时单数: {{ kefuxiangqing.overTimeCount }}
                          </a-button>
                          <a-button type="primary" @click="showgetOverForzenlist(kefuxiangqing.userId)">
                            冻结订单数: {{ kefuxiangqing.forzenOrderCount }}
                          </a-button>
                        </div>
                      </a-modal>
                    </a-col>
                  </a-row>
                </div>
                <a-modal title="客服超时单查询" v-model="visibleTime" @ok="handleTimeOk" :width="900" :footer="false">
                  <!--<div v-for="item in getOverTimelist">-->
                  <!--<p>单号:{{ item.orderNo }}</p>-->
                  <!--<p>超时信息:{{ item.orderMsgs }}</p>-->
                  <!--<p>客户名称:{{ item.clientName }}</p>-->
                  <!--<p>主负责人:{{ item.stuffName }}</p>-->
                  <!--</div>-->
                  <a-table bordered :columns="OverTimeColumns" :data-source="getOverTimelist"> </a-table>
                </a-modal>
                <a-modal
                  title="客服冻结单查询"
                  v-model="visibleForzen"
                  @ok="handleForzenOk"
                  :width="900"
                  :footer="false"
                >
                  <a-table bordered :columns="ForzenTimeColumns" :data-source="getForzenTimelist"> </a-table>
                  <!--<div v-for="item in getForzenTimelist">-->
                  <!--<p>单号:{{ item.orderNo }}</p>-->
                  <!--<p>超时信息:{{ item.orderMsgs }}</p>-->
                  <!--<p>客户名称:{{ item.clientName }}</p>-->
                  <!--<p>主负责人:{{ item.stuffName }}</p>-->
                  <!--</div>-->
                </a-modal>
              </div>
            </a-col>
            <a-col :span="12">
              <div style="background: white; width: 100%; padding: 10px" v-if="customerService">
                <p style="font-weight: bold; font-size: 18px" class="center ptb-10">本年度前十企业总订单量统计</p>
                <div id="main" :style="{ width: 'auto', height: '470px' }"></div>
              </div>
            </a-col>
          </a-row>
          <!-- 全部通知公告 -->
          <a-modal
            title="通知公告"
            style="top: 20px"
            :width="800"
            v-model="dateMode2"
            :confirmLoading="confirmLoading"
            @ok="handleSubmit"
          >
            <a-table size="default" ref="table" rowKey="accessoryId" :columns="columns2" :dataSource="notice4">
              <span slot="importance" slot-scope="text, record">
                {{ render(text) }}
              </span>
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">详情</a>
              </span>
            </a-table>
          </a-modal>
          <!-- 通知公告详情 -->
          <a-modal
            title=""
            style="top: 20px"
            :width="800"
            v-model="dateModel"
            :confirmLoading="confirmLoading2"
            @cancel="handleClose"
            :closable="false"
            @ok="handleSubmit"
          >
            <strong style="padding: 10px; font-size: 24px">
              <span style="float: left; margin-left: 15px">{{ title }}</span>
              <span style="float: right; margin-right: 15px">{{ startTime }}</span>
            </strong>
            <a-divider></a-divider>
            <div style="overflow: hidden" v-html="releaseScope"></div>
            <!--<editor id="tinymce" v-model="releaseScope"  :init="init"></editor>-->
            <!--<a-input v-model="releaseScope" disabled="disabled"/>-->
          </a-modal>
        </div>
        <backlog ref="back" @ok="changeBack"></backlog>
        <a-modal
          title="排序"
          style="top: 20px"
          :width="400"
          v-model="visible2"
          @ok="handleSort"
          @cancel="sortClose"
          :maskClosable="false"
        >
          <a-row>
            <a-col
              id="hezi"
              :span="12"
              style="
                margin: 5px;
                overflow: hidden;
                overflow-y: scroll;
                border: 1px solid #ccc;
                width: 350px;
                padding: 10px 30px;
                height: 400px;
              "
            >
              <a-row v-for="(item, i) in sortList" :key="item.dataIndex" style="padding-top: 15px">
                <a-col :span="10">
                  <a-radio-group v-model="value" @change="onChangeradio(i)">
                    <a-radio :style="radioStyle" :value="item.menuId"> {{ item.sort }}. {{ item.menuName }} </a-radio>
                  </a-radio-group>
                  <!--<a-checkbox @change="onChangeright(i,$event)" style="height:-->
                  <!--30px">{{item-->
                  <!--.title}}</a-checkbox>-->
                </a-col>
                <br />
              </a-row>
            </a-col>
          </a-row>
          <a-row type="flex" justify="space-between" style="margin-top: 20px">
            <a-col :span="1" style="display: flex; justify-content: space-between"> </a-col>
            <a-col :span="6" style="width: 90%">
              <a-button type="primary" @click="up"> 上移 </a-button>
              <a-button type="primary" style="margin-left: 8px" @click="down"> 下移 </a-button>
            </a-col>
          </a-row>
        </a-modal>
      </a-col>
      <a-col :span="6" style="background: #fff; min-height: 75vh" v-if="userType == 22 && false">
        <div class="pd-50">
          <div class="center">
            <img src="@/assets/logo3.png" alt="" style="width: 80px; height: 80px" />
          </div>
          <div class="center mt-15 bold">{{ enterpriseName }}</div>
        </div>
        <div class="center">账户余额</div>
        <div class="blue center size-34 bold">￥{{ enterpriseName }}</div>
        <div class="center mt-60">
          <router-link to="/wallet/recharge">
            <a-button type="primary" class="mr-20"> 立即充值 </a-button>
          </router-link>
          <router-link to="/wallet/walletList">
            <a-button type="Default" plain> 消费明细 </a-button>
          </router-link>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {
  getLine,
  getAllIcon,
  orderLink,
  updateWeight,
  getSpcialTypeWeightNum,
  getOrderTypeWeightNum,
  getOrderTypeList,
  basicData,
  getTPbApartmentEmployee48List,
  getxiangqingInfo,
  getOverTime,
  topTenOfEnterprise,
  getForzenTime,
} from '@/api/workflow/process'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/image'
import store from '@/store'
import { checkPermission } from '@/utils/permissions'
import { timeFix } from '@/utils/util'
import { mapState, mapActions, mapGetters } from 'vuex'
import { PageView } from '@/layouts'
import HeadInfo from '@/components/tools/HeadInfo'
import DetailList from '@/components/tools/DetailList'
import Backlog from '@/views/tools/Backlog'
import { getRoleList, getServiceList } from '@/api/manage'
import { Radar } from '@/components'
import { Timeline } from 'ant-design-vue'
// import 'tinymce/plugins/media'
const TimelineItem = Timeline.Item
const DetailListItem = DetailList.Item
const DataSet = require('@antv/data-set')
// 通知公告
const tongzhidata = []
// list 待办事项
const daibancolumns = [
  {
    title: '页面名称',
    dataIndex: 'age',
    key: 'age',
    className: 'column-money',
    size: 'small',
  },
  {
    title: '事件名称',
    dataIndex: 'age',
    key: 'age',
    className: 'column-money',
  },
  {
    title: '事件ID',
    dataIndex: 'age',
    key: 'age',
    className: 'column-money',
  },
  {
    title: '方案名称',
    dataIndex: 'age',
    key: 'age',
    className: 'column-money',
  },
  {
    title: '成功数',
    dataIndex: 'age',
    key: 'age',
    className: 'column-money',
  },
  {
    title: '失败数',
    dataIndex: 'age',
    key: 'age',
    className: 'column-money',
  },
  {
    title: '负责人',
    dataIndex: 'age',
    key: 'age',
    className: 'column-money',
  },
  {
    title: '操作',
    dataIndex: 'age',
    key: 'age',
    className: 'column-money',
  },
]
const daibandata = [
  {
    key: '1',
    name: '详情',
    age: 32,
    tags: ['nice', 'developer'],
  },
  {
    key: '2',
    name: '详情',
    age: 42,
    tags: ['loser'],
  },
  {
    key: '3',
    name: '详情',
    age: 32,
    tags: ['cool', 'teacher'],
  },
  {
    key: '4',
    name: '详情',
    age: 32,
    tags: ['nice', 'developer'],
  },
  {
    key: '5',
    name: '详情',
    age: 42,
    tags: ['loser'],
  },
  {
    key: '6',
    name: '详情',
    age: 23,
    tags: ['cool', 'teacher'],
  },
  {
    key: '7',
    name: '详情',
    age: 23,
    tags: ['cool', 'teacher'],
  },
]
export default {
  name: 'Workplace',
  components: {
    PageView,
    HeadInfo,
    DetailListItem,
    TimelineItem,
    Radar,
    Editor,
    Backlog,
  },

  data() {
    return {
      option: {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        legend: {
          data: [],
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [],
      },
      store,
      top_list: 0,
      value: '',
      isActive: '',
      isActive2: '',
      columns2: [
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '标题',
          dataIndex: 'title',
        },
        {
          title: '公告类型',
          dataIndex: 'importance',
          scopedSlots: { customRender: 'importance' },
        },
        {
          title: '时间',
          dataIndex: 'startTime',
        },
      ],
      OverTimeColumns: [
        {
          title: '客服ID',
          dataIndex: 'userId',
          align: 'center',
        },
        {
          title: '单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '超时信息',
          dataIndex: 'orderMsgs',
          align: 'center',
        },
        {
          title: '客户名称',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '主负责人',
          dataIndex: 'stuffName',
          align: 'center',
        },
      ],
      ForzenTimeColumns: [
        {
          title: '客服ID',
          dataIndex: 'userId',
          align: 'center',
        },
        {
          title: '单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '冻结信息',
          dataIndex: 'orderMsgs',
          align: 'center',
        },
        {
          title: '客户名称',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '主负责人',
          dataIndex: 'stuffName',
          align: 'center',
        },
      ],

      // 富文本
      init: {
        language_url: '/tinymce/langs/zh_CN.js', //语言包的路径
        language: 'zh_CN', //语言
        skin_url: '/tinymce/skins/ui/oxide', //skin路径
        height: 300, //编辑器高度
        branding: false, //是否禁用“Powered by TinyMCE”
        menubar: false, //顶部菜单栏显示,
        images_upload_handler: (blobInfo, success, failure) => {
          const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          success(img)
        },
        video_template_callback: function (data) {},
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount media',
        ],
        toolbar:
          'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image media  code | removeformat',
      },

      //通知公告信息
      title: '',
      startTime: '',
      releaseScope: '',
      notice2: [],
      notice: [],
      // 通知公告详情
      notice3: '',
      // 全部通知公告
      notice4: '',
      //通知公告详情页面判断是否显示
      dateModel: false,
      //显示所有公告
      dateMode2: false,
      kefuWidth: 800,
      kefuHeight: 400,
      visible: false,
      visible2: false,
      visibleTime: false,
      visibleForzen: false,
      zaixiankefu: [],
      kefuxiangqing: [],
      getOverTimelist: [],
      getForzenTimelist: [],
      topTenOfEnterpriselist: [],
      daibancolumns,
      daibandata,
      tongzhidata,
      timeFix: timeFix(),
      avatar: '',
      user: {},
      workonstuff: [],
      projects: [],
      loading: true,
      radarLoading: true,
      activities: [],
      teams: [],
      status: '',
      estimate: 0, //按钮样式判断
      carouselList: [], //轮播list
      sortList: [], //排序，合并所有数据
      dataList: [],
      // data
      axis1Opts: {
        dataKey: 'item',
        line: null,
        tickLine: null,
        grid: {
          lineStyle: {
            lineDash: null,
          },
          hideFirstLine: false,
        },
      },
      axis2Opts: {
        dataKey: 'score',
        line: null,
        tickLine: null,
        grid: {
          type: 'polygon',
          lineStyle: {
            lineDash: null,
          },
        },
      },
      scale: [
        {
          dataKey: 'score',
          min: 0,
          max: 80,
        },
      ],
      axisData: [
        {
          item: '引用',
          a: 70,
          b: 30,
          c: 40,
        },
        {
          item: '口碑',
          a: 60,
          b: 70,
          c: 40,
        },
        {
          item: '产量',
          a: 50,
          b: 60,
          c: 40,
        },
        {
          item: '贡献',
          a: 40,
          b: 50,
          c: 40,
        },
        {
          item: '热度',
          a: 60,
          b: 70,
          c: 40,
        },
        {
          item: '引用',
          a: 70,
          b: 50,
          c: 40,
        },
      ],
      changeList: [
        {
          title: '1.0.2-SNAPSHOT 2019-09-30',
          color: 'green',
          list: [
            '优化角色授权实现联动和半选',
            '用户管理增加部门检索功能',
            '代码生成增加树形模板',
            '代码生成模板适配vue',
            '分布式文件系统',
            '修复代码生成前缀无法自动去除',
            '操作日志增加请求方法',
            '移除jwt依赖',
            'swagger接口文档支持',
            '前端i18n国际化支持',
            '增加vue代码生成（部分）',
            'vue-cropper头像组件',
          ],
        },
      ],
      radarData: [],
      interiorTop: checkPermission('interior:top'),
      customerService: checkPermission('customerService'),
      customerOrder: checkPermission('customer:order'),
      enterpriseId: this.$store.getters.enterpriseId, // 企业ID
      totalBalance: '', //企业余额
      enterpriseName: '', //企业名称
    }
  },
  computed: {
    ...mapState({
      nickname: (state) => state.user.nickname,
      welcome: (state) => state.user.welcome,
    }),
    // 00系统用户，11师傅，22企业，33客户,44团队团员,55团队子账号,66锁协
    ...mapGetters(['nickname', 'avatar']),
    userType() {
      return this.$store.getters.userType
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    num() {
      return this.carouselList.length
    },
  },
  created() {
    //通知公告
    basicData({ run: 1 }).then((res) => {
      // console.log(res)
      this.notice = res.rows
      this.notice2 = []
      // console.log(this.notice)
      for (var i = 0; i < this.notice.length; i += 5) {
        this.notice2.push(this.notice.slice(i, i + 5))
      }
      // console.log(this.notice2)
    })
    // 首页轮播加载优化
    // getAllIcon().then(res=>{
    //   this.carouselList = res.rows
    // }).then(res =>{
    //   this.change1()
    // })
    // // 人员数据
    this.change1()
    this.showWorkDay()
    this.topTenOfEnterpriseday()
    this.information()
  },
  mounted() {
    tinymce.init({})
    this.getAllLine()
    window.onresize = () => {
      let myChart = this.$echarts.init(document.getElementById('main'))
      myChart.resize()
    }
  },
  methods: {
    // 折线图数据
    getAllLine() {
      let myChart = this.$echarts.init(document.getElementById('main'))
      getLine().then((res) => {
        if (res.code == 0) {
          this.option.series = res.data.series
          this.option.xAxis[0].data = res.data.data
          myChart.setOption(this.option)
        }
      })
    },
    // 排序
    getSort() {
      this.value = ''
      this.sortList = []
      for (let i = 0; i < this.dataList.length; i++) {
        this.sortList.push(this.dataList[i])
      }
      this.visible2 = true
    },
    onChangeradio(value) {
      console.log(value)
      this.top_list = value
    },
    up() {
      if (this.top_list > 0) {
        this.top_list--
        document.getElementById('hezi').scrollTop = this.top_list * 30
      }
      console.log(this.value)
      for (let i = 0; i < this.sortList.length; i++) {
        if (this.sortList[i].menuId == this.value) {
          if (i != -1 && i != 0) {
            ;[this.sortList[i - 1], this.sortList[i]] = [this.sortList[i], this.sortList[i - 1]]
          }
          let keys = []
          this.sortList.forEach((key) => keys.push(key))
          this.sortList = keys
        }
      }
    },
    down() {
      if (this.top_list < this.sortList.length) {
        this.top_list++
        document.getElementById('hezi').scrollTop = this.top_list * 30
      }
      for (let i = this.sortList.length - 1; i > -1; i--) {
        if (this.sortList[i].menuId == this.value) {
          if (i != -1 && i != this.sortList.length - 1) {
            ;[this.sortList[i + 1], this.sortList[i]] = [this.sortList[i], this.sortList[i + 1]]
          }
          let keys = []
          this.sortList.forEach((key) => keys.push(key))
          this.sortList = keys
        }
      }
    },
    render(text) {
      return text == 0 ? '普通公告' : text == 1 ? '重要公告' : ''
    },
    handleSort() {
      // console.log(this.sortList)
      let orderTypeWeights = []
      for (let val in this.sortList) {
        let str = {
          orderTypeId: this.sortList[val].menuId,
          weight: parseInt(val) + 1,
        }
        orderTypeWeights.push(str)
      }
      // console.log(orderTypeWeights)
      updateWeight({ orderTypeWeights: orderTypeWeights }).then((res) => {
        // console.log(res)
        if (res.code == 0) {
          this.$message.success('排序成功')
          if ((this.estimate = 0)) {
            this.change1()
          } else {
            this.change2()
          }
          this.visible2 = false
        }
      })
    },
    handleSubmit() {
      this.dateModel = false
      this.dateMode2 = false
    },
    handleClose() {
      // console.log(this.status)
      this.dateModel = false
      if (this.status == 1) {
        this.dateMode2 = true
      }
    },
    //通知公告详情
    handleEdit(record) {
      // console.log(record)
      this.status = 1
      getOrderTypeList(record.id).then((res) => {
        // console.log(res)
        this.dateMode2 = false
        this.dateModel = true
        this.title = res.title
        this.releaseScope = res.content
      })
    },
    // 全部通知
    whole() {
      this.dateModel = false
      this.dateMode2 = true
      basicData({ run: '' }).then((res) => {
        // console.log(res)
        this.notice4 = res.rows
        // console.log(this.notice4)
        // for(var i=0;i<this.notice.length;i+=5) {
        //   this.notice2.push(this.notice.slice(i, i + 5));
        // }
      })
    },
    // change1(){
    //   this.estimate = 0
    //   // 未指定人员数据
    //   getOrderTypeWeightNum().then(res=>{
    //     // console.log(res.rows)
    //     var alloldlist=res.rows
    //     this.carouselList = [res.rows[0]]
    //     var _this=this
    //     setTimeout(function(){
    //       _this.carouselList=res.rows
    //       let result = [];
    //       _this.sortList = []
    //       _this.dataList = []
    //       for (let i = 0; i < res.rows.length; i++) {
    //         result = result.concat(res.rows[i]);
    //       }
    //       // 原数组
    //       for(let a=0;a<result.length;a++){
    //         result[a]['sort'] = a+1
    //         _this.dataList.push(result[a])
    //       }
    //       // this.dataList = result
    //       // 克隆
    //       for(let b=0;b<_this.dataList.length;b++){
    //         _this.sortList.push(_this.dataList[b])
    //       }
    //     },500)
    //   })
    // },
    change1() {
      this.estimate = 0
      // 未指定人员数据
      getOrderTypeWeightNum().then((res) => {
        this.carouselList = res.rows
        let result = []
        this.sortList = []
        this.dataList = []
        for (let i = 0; i < res.rows.length; i++) {
          result = result.concat(res.rows[i])
        }
        // 原数组
        for (let a = 0; a < result.length; a++) {
          result[a]['sort'] = a + 1
          this.dataList.push(result[a])
        }
        // this.dataList = result
        // 克隆
        for (let b = 0; b < this.dataList.length; b++) {
          this.sortList.push(this.dataList[b])
        }
      })
    },
    change2() {
      this.estimate = 1
      // 指定人员数据
      getSpcialTypeWeightNum().then((res) => {
        this.carouselList = res.rows
        // console.log(this.carouselList)
        let result = []
        this.sortList = []
        this.dataList = []
        for (let i = 0; i < res.rows.length; i++) {
          result = result.concat(res.rows[i])
        }
        // 原数组
        for (let a = 0; a < result.length; a++) {
          result[a]['sort'] = a + 1
          this.dataList.push(result[a])
        }
        this.dataList = result
        // 克隆
        for (let b = 0; b < this.dataList.length; b++) {
          this.sortList.push(this.dataList[b])
        }
      })
    },

    change3(list) {
      console.log('list', list)
      this.$axios({
        method: 'post',
        url: '/api/stuff/stuff/getuser',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        console.log(res.data)
        this.queryParam = res.data.data
        console.log('123', this.queryParam)
      })
    },

    //通知公告详情
    onchange(value) {
      this.status = 0
      getOrderTypeList(value.id).then((res) => {
        // console.log(res)
        this.dateModel = true
        this.title = res.title
        this.startTime = res.startTime
        this.releaseScope = res.content
      })
    },

    // diver() {
    //   var sUserAgent = navigator.userAgent.toLowerCase()
    //   var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
    //   var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
    //   var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
    //   var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
    //   var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
    //   var bIsAndroid = sUserAgent.match(/android/i) == 'android'
    //   var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
    //   var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
    //
    //   if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
    //     alert('当前是电脑打开')
    //   } else {
    //     alert('当前是手机打开')
    //   }
    // },
    showModal(value) {
      this.visible = true
      this.showPopup(value)
    },
    handleOk(e) {
      // console.log(e)
      this.visible = false
    },
    handleTimeOk(e) {
      this.visibleTime = false
    },
    handleForzenOk(e) {
      this.visibleForzen = false
    },
    // 超时
    showgetOverTimelist(userId) {
      this.visibleTime = true
      getOverTime({ userId: userId })
        .then((res) => {
          this.getOverTimelist = res.rows
          // console.log(res)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 冻结
    showgetOverForzenlist(userId) {
      this.visibleForzen = true
      getForzenTime({ userId: userId })
        .then((res) => {
          this.getForzenTimelist = res.rows
          // console.log(res)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showWorkDay(day) {
      this.isActive2 = 1
      getTPbApartmentEmployee48List({ daySearch: 'day' })
        .then((res) => {
          // console.log(res)
          this.zaixiankefu = res.rows
          // console.log(this.zaixiankefu)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showWorkWeek(week) {
      this.isActive2 = 2
      getTPbApartmentEmployee48List({ daySearch: 'week' })
        .then((res) => {
          // 前面的键key 后面的是值value，值（如果是变量不要加引号，反之）。
          // console.log(res)
          this.zaixiankefu = res.rows
          console.log(this.zaixiankefu)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showWorkMonth(month) {
      this.isActive2 = 3
      getTPbApartmentEmployee48List({ daySearch: 'mon' })
        .then((res) => {
          // console.log(res)
          this.zaixiankefu = res.rows
          // console.log(this.zaixiankefu)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showWorkAll(all) {
      this.isActive2 = 4
      getTPbApartmentEmployee48List({ daySearch: 'all' })
        .then((res) => {
          // console.log(res)
          this.zaixiankefu = res.rows
          // console.log(this.zaixiankefu)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    topTenOfEnterpriseday(day) {
      this.isActive = 1
      topTenOfEnterprise({ daySearch: 'day', isAuthority: 1 })
        .then((res) => {
          // console.log(res)
          this.topTenOfEnterpriselist = res.rows
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    topTenOfEnterprisemon(mon) {
      this.isActive = 2
      topTenOfEnterprise({ daySearch: 'mon', isAuthority: 1 })
        .then((res) => {
          // console.log(res)
          this.topTenOfEnterpriselist = res.rows
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    topTenOfEnterpriselastmon(lastmon) {
      this.isActive = 3
      topTenOfEnterprise({ daySearch: 'lastmon', isAuthority: 1 })
        .then((res) => {
          // console.log(res)
          this.topTenOfEnterpriselist = res.rows
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    topTenOfEnterpriseall(all) {
      this.isActive = 4
      topTenOfEnterprise({ daySearch: 'all', isAuthority: 1 })
        .then((res) => {
          // console.log(res)
          this.topTenOfEnterpriselist = res.rows
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showPopup(userId) {
      this.show = true
      getxiangqingInfo({ userId: userId })
        .then((res) => {
          this.kefuxiangqing = res.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getTeams() {
      this.$http.get('/workplace/teams').then((res) => {
        this.teams = res.result
        this.loading = false
      })
    },
    initRadar() {
      this.radarLoading = true

      this.$http.get('/workplace/radar').then((res) => {
        const dv = new DataSet.View().source(res.result)
        dv.transform({
          type: 'fold',
          fields: ['个人', '团队', '部门'],
          key: 'user',
          value: 'score',
        })
        this.radarData = dv.rows
        this.radarLoading = false
      })
    },
    // 首页跳转
    handleJump(list) {
      if (list.num != 0) {
        this.$nextTick(() => {
          if (list.jumpPage == '1') {
            this.$router.push({
              name: this.$store.state.user_type == 1 ? 'orderList' : 'orderList1',
              params: {
                id: list.menuId,
                status: this.estimate,
                jumpList: list.queryParam,
              },
            })
          } else if (list.jumpPage == '2') {
            this.$refs.back.add('complaints')
          } else if (list.jumpPage == '3') {
            this.$refs.back.add('back')
          } else if (list.jumpPage == '4') {
            this.$router.push({
              name: 'MasterOrderList',
              params: {
                id: list.menuId,
                jumpList: list.queryParam,
              },
            })
          }
        })
      } else {
        this.$message.error('暂无信息')
      }
    },
    // 账户信息
    information() {
      this.$axios({
        method: 'get',
        url: '/api/finance/refund/get/' + `${this.enterpriseId}`,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        this.enterpriseName = res.data.data.enterpriseName
        this.totalBalance = res.data.data.totalBalance
      })
    },
  },
  watch: {
    $route(to, from) {
      if (to.path == '/dashboard/weclome') {
        this.showWorkDay()
        this.topTenOfEnterpriseday()
        if (localStorage.getItem('estimateCode') == 0 || !localStorage.getItem('estimateCode')) {
          this.estimate = 0
          this.change1()
        } else {
          this.estimate = 1
          this.change2()
        }
        basicData({ run: 1 }).then((res) => {
          // console.log(res)
          this.notice2 = []
          this.notice = res.rows
          // console.log(this.notice)
          for (var i = 0; i < this.notice.length; i += 5) {
            this.notice2.push(this.notice.slice(i, i + 5))
          }
          // console.log(this.notice2)
        })
      }

      if (from.path == '/dashboard/weclome') {
        localStorage.setItem('estimateCode', this.estimate)
      }
      this.information()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-carousel .slick-dots {
  bottom: -10px !important;
}

/deep/ .ant-carousel .slick-dots li.slick-active button {
  background: #f77;
  opacity: 1;
  width: 24px;
}

/deep/ .ant-carousel .slick-dots li button {
  background: #1890ff;
}

/* For demo */
/*.slick-slide .slick-active .slick-current{*/
/*text-align: center;*/
/*height: 160px;*/
/*line-height: 160px;*/
/*background: #364d79;*/
/*overflow: hidden;*/
/*}*/

/*.ant-carousel .slick-slide h3{*/
/*color: #fff;*/
/*}*/

.getcolor1 {
  background-color: #1890ff;
  color: #fff;
}

.qiyeshutd {
  padding-bottom: 19.5px;
}

.qiyeshujutd {
  padding-bottom: 18.9px;
}

/deep/ .activeStyle {
  // color: #72d3ff !important;
  background-color: #1890ff !important;
}

.qiyedanshuju {
  background-color: #1890ff5e;
  /*width: 120px;*/
  color: white;
  font-size: 16px;
  border: none;
}

#xiangqing {
  color: #1890ff;
  font-size: 14px;
}

#kefu {
  list-style: none;
  padding: 0px;
}

.topddiv {
  display: inline-block;
}

.qiyedanshu li {
  margin-top: 15px;
}

.zaowujie {
  color: #ff0000;
}

.qiyedanshu {
  list-style: none;
}

#ddiv .cca {
  border: 1px solid #1890ff;
}

#ddiv .cca .cool {
  border: 1px solid yellow;
}

#con-ul {
  list-style: none;
}

.changList {
  margin-top: -14px;
}

.members {
  a {
    display: block;
    margin: 12px 0;
    line-height: 24px;
    height: 24px;

    .member {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 24px;
      max-width: 100px;
      vertical-align: top;
      margin-left: 12px;
      transition: all 0.3s;
      display: inline-block;
    }

    &:hover {
      span {
        color: #1890ff;
      }
    }
  }
}

.new-btn {
  background-color: #fff;
  border-radius: 2px;
  width: 100%;
  height: 188px;
}

.ant-card-body {
  padding: 0px !important;
}

.radio {
  background-color: #1890ff;
}
</style>
